import { Stack, SxProps, Theme, Typography } from "@mui/material";
import { useLocalization } from "../hooks/useLocalization";
import DataErrorDialogIcon from "../icons/DataErrorDialogIcon";

interface Props {
  title?: string;
  text?: string;
  sx?: SxProps<Theme>;
}

const DataLoadingFailed = ({ text, title, sx }: Props) => {
  const { common: locale } = useLocalization();

  return (
    <Stack alignItems="center" justifyContent="center" spacing={2} flex={1} sx={sx}>
      <DataErrorDialogIcon sx={{ width: 80, height: 80 }} />
      <Stack spacing={1} alignItems="center" justifyContent="center">
        <Typography variant="h6">{title || locale.dataLoadingFailed.title}</Typography>
        <Typography textAlign="center">{text ?? locale.dataLoadingFailed.text}</Typography>
      </Stack>
    </Stack>
  );
};

export default DataLoadingFailed;
